export const endpointData = [
    {
      endpointName: "FULL EMAIL CHECK",
      categories: "Ecommerce, Identidad Digital, Prevención de Fraude",
      countries: "Global",
      description: "Una solución para perfilar a tus usuarios digitales basándote en el análisis de su correo electrónico y su actividad en redes sociales y otros perfiles online. Obtén un score del nivel de riesgo asociado al correo electrónico para evitar posibles fraudes o pérdidas. Integrando esta API al inicio de tus procesos, podrás mitigar hasta un 60% el fraude electrónico.",
      id: "a6cc88ec-6a7a-4b98-9274-f9645a50d062",
      endpointTitle: "Comprobación completa del correo electrónico",
      endpointDescription: "Agrega cientos de fuentes de datos en redes sociales abiertas y accesibles para proporcionar una herramienta de investigación de emails en profundidad.",
      params: [
        {name: "email", value: "Email a ser validado", demoValue: "test2023-10-30ev2@gmail.com"}
      ],
      response: `"data": {
    "email": "test2023-10-30ev2@gmail.com",
    "score": 11,
    "deliverable": false,
    "domain_details": {
     "domain": "gmail.com",
     "tld": ".com",
     "registered": true,
     "created": "1995-08-13 04:00:00",
     "updated": "2023-07-11 10:10:13",
     "expires": "2024-08-12 04:00:00",
     "registrar_name": "MarkMonitor Inc.",
     "registered_to": "Google LLC",
     "disposable": false,
     "free": true,
     "custom": false,
     "dmarc_enforced": true,
     "spf_strict": true,
     "valid_mx": true,
     "accept_all": false,
     "suspicious_tld": false,
     "website_exists": true
    },
    "account_details": {
     "apple": {
      "registered": false
     },
     "ebay": {
      "registered": false
     },
     "facebook": {
      "registered": false,
      "url": null,
      "name": null,
      "photo": null
     },
     "flickr": {
      "registered": false,
      "username": null,
      "photo": null,
      "followers": null,
      "location": null,
      "occupation": null,
      "description": null
     },
     "foursquare": {
      "registered": null,
      "bio": null,
      "photo": null,
      "profile_url": null
     },
     "github": {
      "registered": false,
      "photo": null,
      "full_name": null,
      "username": null,
      "location": null,
      "company": null,
      "website": null,
      "bio": null,
      "followers": null,
      "following": null,
      "twitter": null,
      "profile_url": null
     },
     "google": {
      "registered": false,
      "photo": null,
      "activity": {
       "reviews": null,
       "ratings": null,
       "photos": null,
       "videos": null,
       "answers": null,
       "edits": null,
       "places_added": null,
       "roads_added": null,
       "facts_checked": null,
       "published_lists": null,
       "q_and_a": null
      },
      "is_enterprise_user": null,
      "last_updated": null
     },
     "gravatar": {
      "registered": false,
      "location": null,
      "name": null,
      "profile_url": null,
      "username": null
     },
     "instagram": {
      "registered": false
     },
     "lastfm": {
      "registered": null
     },
     "linkedin": {
      "registered": null,
      "url": null,
      "name": null,
      "company": null,
      "title": null,
      "location": null,
      "website": null,
      "twitter": null,
      "photo": null,
      "connection_count": null
     },
     "microsoft": {
      "registered": false
     },
     "myspace": {
      "registered": false
     },
     "pinterest": {
      "registered": false
     },
     "skype": {
      "registered": false,
      "country": null,
      "country_code": null,
      "city": null,
      "gender": null,
      "name": null,
      "id": null,
      "handle": null,
      "bio": null,
      "age": null,
      "language": null,
      "state": null,
      "photo": null,
      "contact_type": null
     },
     "spotify": {
      "registered": false
     },
     "tumblr": {
      "registered": false
     },
     "twitter": {
      "registered": false
     },
     "vimeo": {
      "registered": false
     },
     "weibo": {
      "registered": false
     },
     "yahoo": {
      "registered": false
     },
     "discord": {
      "registered": false
     },
     "ok": {
      "registered": false,
      "city": null,
      "age": null,
      "date_joined": null,
      "full_name": null
     },
     "kakao": {
      "registered": null
     },
     "booking": {
      "registered": false
     },
     "airbnb": {
      "registered": null,
      "about": null,
      "created_at": null,
      "first_name": null,
      "identity_verified": null,
      "location": null,
      "image": null,
      "reviewee_count": null,
      "trips": null,
      "work": null
     },
     "amazon": {
      "registered": null
     },
     "qzone": {
      "registered": false
     },
     "adobe": {
      "registered": false
     },
     "mailru": {
      "registered": false
     },
     "wordpress": {
      "registered": false
     },
     "imgur": {
      "registered": false
     },
     "disneyplus": {
      "registered": false
     },
     "netflix": {
      "registered": false
     },
     "jdid": {
      "registered": null
     },
     "flipkart": {
      "registered": false
     },
     "bukalapak": {
      "registered": false
     },
     "archiveorg": {
      "registered": false
     },
     "lazada": {
      "registered": false
     },
     "zoho": {
      "registered": false
     },
     "samsung": {
      "registered": false
     },
     "evernote": {
      "registered": false
     },
     "envato": {
      "registered": false
     },
     "patreon": {
      "registered": false
     },
     "tokopedia": {
      "registered": false
     },
     "rambler": {
      "registered": false
     },
     "quora": {
      "registered": false
     },
     "atlassian": {
      "registered": false
     },
     "aboutme": {
      "registered": false
     },
     "altbalaji": {
      "registered": false
     },
     "bitmoji": {
      "registered": false
     },
     "bodybuilding": {
      "registered": false
     },
     "codecademy": {
      "registered": false
     },
     "deliveroo": {
      "registered": false
     },
     "diigo": {
      "registered": false
     },
     "duolingo": {
      "registered": false,
      "full_name": null,
      "photo": null,
      "registered_at": null,
      "country": null,
      "username": null,
      "has_recent_activity": null,
      "learning_language": null,
      "from_language": null,
      "email_verified": null,
      "courses": null
     },
     "eventbrite": {
      "registered": false
     },
     "firefox": {
      "registered": false
     },
     "freelancer": {
      "registered": false
     },
     "gaana": {
      "registered": false
     },
     "giphy": {
      "registered": false
     },
     "hubspot": {
      "registered": false
     },
     "kommo": {
      "registered": false
     },
     "komoot": {
      "registered": false
     },
     "nike": {
      "registered": false
     },
     "plurk": {
      "registered": false
     },
     "rappi": {
      "registered": false
     },
     "replit": {
      "registered": false
     },
     "seoclerks": {
      "registered": false
     },
     "snapchat": {
      "registered": false
     },
     "snapdeal": {
      "registered": null
     },
     "soundcloud": {
      "registered": false
     },
     "starz": {
      "registered": false
     },
     "strava": {
      "registered": false
     },
     "taringa": {
      "registered": false,
      "username": null,
      "photo": null
     },
     "tiki": {
      "registered": false
     },
     "treehouse": {
      "registered": false
     },
     "venmo": {
      "registered": false
     },
     "vivino": {
      "registered": false
     },
     "vkontakte": {
      "registered": false
     },
     "wattpad": {
      "registered": false
     },
     "xing": {
      "registered": false
     },
     "yandex": {
      "registered": false
     },
     "adult_sites": {
      "registered": false
     }
    },
    "breach_details": {
     "haveibeenpwned_listed": false,
     "number_of_breaches": 0,
     "first_breach": null,
     "breaches": []
    },
    "applied_rules": [
     {
      "id": "E114",
      "name": "Domain is a free provider. No online profiles were found. It was not involved in a data breach",
      "operation": "+",
      "score": 10
     },
     {
      "id": "E122",
      "name": "5 or more digits in email handle or in username",
      "operation": "+",
      "score": 1
     }
    ],
    "id": "3de42a30-9603-4316-aae2-12ad9894fb21",
    "history": {
     "hits": 2,
     "customer_hits": 1,
     "first_seen": 1698669982,
     "last_seen": 1698669982
    },
    "flags": []
}`
    },
    {
      endpointName: "CURP",
      categories: "KYC, Prevención de Fraude",
      countries: "México",
      description: "Verifica la CURP (Clave Única de Registro de Población) y la información personal de cuaquier ciudadano mexicano o residente legal a través de RENAPO (Registro Nacional de Población). Busca utilizando la CURP o mediante información personal (nombre completo, género, fecha y lugar de nacimiento).",
      id: "48662deb-c14d-453e-9784-70832a7605e0",
      endpointTitle: "Validación de CURP",
      endpointDescription: "Validar la CURP a través de RENAPO",
      params: [
        {name: "curp", value: "CURP a ser consultado", demoValue: "AAAM111111HHSSSS00"}
      ],
      response: `{
    "birthdate": "01/01/1900",
    "curp": "XXXX000000XXXXXX00",
    "entity_birth": "XX",
    "homonimo": false,
    "mothers_maiden_name": "SURNAME",
    "names": "NAME",
    "nationality": "NATIONALITY",
    "paternal_surname": "SURNAME",
    "probation_document": "DOCUMENT TYPE",
    "probation_document_data": {
        "anioReg": "1900",
        "crip": "",
        "cveEntidadEmisora": "",
        "cveMunicipioReg": "000",
        "foja": "",
        "folioCarta": "",
        "libro": "",
        "numActa": "00000",
        "numEntidadReg": "00",
        "numRegExtranjeros": "",
        "tomo": ""
    },
    "renapo_valid": true,
    "sex": "SEX",
    "status_curp": "STATUS",
    "transaction_id": "0000000000000000000000000000000000000000000000000000000000000000"
}`
    },
    {
      endpointName: "INE / IFE / PASAPORTE",
      categories: "KYC, Prevención de Fraude",
      countries: "Global",
      description: "Una solución para validar y procesar los INE/IFE y pasaporte mexicanos de manera automática con OCR. El servicio recibe un documento en imagen y devuelve todos los datos en este.",
      endpointTitle: "Validar INE/IFE",
      endpointDescription: "Validar los datos de una credencial en la lista nominal del INE.",
      id: "05c6fc42-c8c6-462d-9448-118800749b92",
      params: [
        {name: "content-type", value: "application/json", isOptional: true, demoValue: "222222222"},
        {name: "cic", value: "Número CIC de la credencial de elector", isOptional: true, demoValue: "123456789"},
        {name: "identificadorCiudadano", value: "Número de identificador ciudadano", isOptional: true},
        {name: "numeroEmision", value: "Número de emisión de la credencial de elector", isOptional: true},
        {name: "claveElector", value: "Clave de elector", isOptional: true},
        {name: "ocr", value: "Número OCR de la credencial de elector", isOptional: true},
      ],
      response: `{
    "mensaje": "Esta vigente como medio de identificacion y puede votar",
    "claveMensaje": "3",
    "codigoValidacion": "vi1619806496.1754942",
    "estatus": "OK",
    "claveElector": "VRCTDG96082209H000",
    "numeroEmision": "0",
    "ocr": "3835098794022",
    "cic": "173438871",
    "anioRegistro": "2014",
    "anioEmision": "2014",
    "vigencia": "31 de diciembre de 2024"
}`
    },
    {
      endpointName: "PHONE CHECK",
      categories: "Identidad Digital, KYC, Prevención de Fraude",
      countries: "Global",
      description: "Una solución donde podrás consultar el número telefónico de tu cliente a nivel global, verificar su validez en la red internacional y obtener la información asociada a dicha línea telefónica.",
      id: "1f581de8-53db-4f27-80ed-3a3afd327f9c",
      endpointTitle: "Validar Número de Teléfono",
      endpointDescription: "Investigar un número de teléfono en profundidad. Formato requerido: +36301234567 o 0036301234567",
      params: [
        {name: "phone", value: "Teléfono a ser validado", demoValue: "+525122334455"}
      ],
      response: `{
    "number": 36200130525,
    "valid": true,
    "disposable": false,
    "type": "mobile",
    "country": "HU",
    "carrier": "Yettel Hungary",
    "score": 4,
    "account_details": {
     "facebook": {
      "registered": false
     },
     "google": {
      "registered": false,
      "account_id": null,
      "full_name": null
     },
     "twitter": {
      "registered": false
     },
     "instagram": {
      "registered": false
     },
     "yahoo": {
      "registered": null
     },
     "microsoft": {
      "registered": false
     },
     "snapchat": {
      "registered": false
     },
     "skype": {
      "registered": false,
      "age": null,
      "city": null,
      "bio": null,
      "country": null,
      "gender": null,
      "language": null,
      "name": null,
      "handle": null,
      "id": null,
      "photo": null,
      "state": null
     },
     "whatsapp": {
      "registered": false,
      "photo": null,
      "last_seen": null,
      "about": null,
      "last_active": null
     },
     "telegram": {
      "registered": null,
      "photo": null,
      "last_seen": null
     },
     "viber": {
      "registered": null,
      "photo": null,
      "last_seen": null,
      "name": null
     },
     "kakao": {
      "registered": null
     },
     "ok": {
      "registered": false,
      "age": null
     },
     "zalo": {
      "registered": false,
      "date_of_birth": null,
      "name": null,
      "uid": null
     },
     "line": {
      "registered": null,
      "name": null,
      "photo": null
     },
     "flipkart": {
      "registered": false
     },
     "bukalapak": {
      "registered": false
     },
     "jdid": {
      "registered": null
     },
     "altbalaji": {
      "registered": false
     },
     "shopclues": {
      "registered": false
     },
     "snapdeal": {
      "registered": null
     },
     "tiki": {
      "registered": false
     },
     "vkontakte": {
      "registered": false
     },
     "weibo": {
      "registered": false
     }
    },
    "applied_rules": [
     {
      "id": "PH102",
      "name": "No online profiles were found",
      "operation": "+",
      "score": 4
     }
    ],
    "id": "c9dcf2ce-9a85-4d16-8761-fce122e682fc",
    "history": {
     "hits": 173,
     "customer_hits": 8,
     "first_seen": 1653484836,
     "last_seen": 1698248016
    },
    "flags": [],
    "hlr_details": {
     "imsi": "216010000000000",
     "original_carrier": {
      "carrier": null,
      "carrier_prefix": "20"
     },
     "ported_carrier": null,
     "roaming_carrier": null,
     "serving_msc": null,
     "status": "delivered"
    },
    "cnam_details": null
}`
    },
    {
      endpointName: "IP CHECK",
      categories: "Ecommerce, Identidad Digital, Prevención de Fraude",
      countries: "Global",
      description: "Con la API IP CHECK, analiza la dirección IP de todos aquellos usuarios que ingresan a tu sitio web o plataforma. Identifica VPN sospechosas, usuarios con navegador TOR y ubicaciones de riesgo en milésimas de segundos. Conoce la ubicación real de los usuarios y donde inician sesión a través del análisis de la dirección IP. No permitas conexión, inicio de sesión o acceso desde direcciones que no convienen a tu negocio. 0-10: El usuario es seguro / 10-20: El usuario puede ser riesgoso / 20 +: El usuario es riesgoso",
      endpointTitle: "Dirección IP",
      endpointDescription: "La API IP verificación determina la probabilidad de que se falsifique una dirección IP utilizando técnicas informáticas modernas, de modo que pueda bloquear TOR, VPN y usuarios de proxy.",
      id: "9dc41379-1865-4415-9eb0-a9a5bb454368",
      params: [
        {name: "id", value: "IP a ser validada", demoValue: "123.123.123.0"}
      ],
      response: `{
    "ip": "1.1.1.1",
    "score": 100,
    "country": "HK",
    "state_prov": "Hong Kong",
    "city": "Hong Kong",
    "timezone_offset": "+08:00",
    "isp_name": "APNIC and CloudFlare DNS Resolver Project",
    "latitude": 22.28552,
    "longitude": 114.15769,
    "type": "CDN",
    "open_ports": [
     80
    ],
    "tor": false,
    "harmful": false,
    "vpn": false,
    "web_proxy": false,
    "public_proxy": false,
    "spam_number": 3,
    "spam_urls": [
     "bl.emailbasura.org",
     "l2.apews.org",
     "dyna.spamrats.com"
    ],
    "applied_rules": [
     {
      "id": "P102",
      "name": "Port 80 is open on the IP address",
      "operation": "+",
      "score": 1
     },
     {
      "id": "P100",
      "name": "There is 1 suspicious open port on the IP address",
      "operation": "+",
      "score": 4
     },
     {
      "id": "P109",
      "name": "IP address was found on 3 spam blacklists",
      "operation": "+",
      "score": 2
     }
    ],
    "history": {
     "hits": 3,
     "customer_hits": 1,
     "first_seen": 1573567581,
     "last_seen": 1573639346
    },
    "flags": [
     {
      "note": "Blacklisted by API",
      "date": 1573138956,
      "industry": "Online gambling operator"
     }
    ],
    "id": "b06c5055-d1bf-4400-b2c9-ab3edd7171d6"
}`
    },
  ];
  